import { generateWithOllama } from "./ollamaClient";

const LOCAL_POLICY_HINT =
  "Sensitive context is restricted to local Ollama execution";

const stripCodeFences = (value) =>
  String(value || "")
    .replace(/```json\s*/gi, "")
    .replace(/```\s*/g, "")
    .trim();

export const parseJsonPayload = (text) => {
  const cleaned = stripCodeFences(text);
  if (!cleaned) return null;

  const firstBracket = Math.min(
    ...[cleaned.indexOf("["), cleaned.indexOf("{")].filter((idx) => idx >= 0)
  );
  const lastBracket = Math.max(cleaned.lastIndexOf("]"), cleaned.lastIndexOf("}"));
  if (firstBracket < 0 || lastBracket <= firstBracket) {
    return null;
  }

  try {
    return JSON.parse(cleaned.slice(firstBracket, lastBracket + 1));
  } catch (error) {
    return null;
  }
};

export const isLocalPolicyBlockedError = (error) => {
  const code = String(error?.code || "").toLowerCase();
  const message = String(error?.message || "").toLowerCase();
  if (message.includes(LOCAL_POLICY_HINT.toLowerCase())) {
    return true;
  }
  return code.includes("failed-precondition") && message.includes("ollama");
};

export const generateLocalText = async ({
  prompt,
  systemPrompt = "",
  model = null,
  temperature = 0.3,
} = {}) => {
  const response = await generateWithOllama({
    prompt,
    systemPrompt,
    model,
    temperature,
  });
  return String(response?.content || "").trim();
};

export const generateLocalJson = async ({
  prompt,
  systemPrompt = "",
  model = null,
  temperature = 0.2,
  maxAttempts = 2,
} = {}) => {
  let lastText = "";

  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    const text = await generateLocalText({
      prompt,
      systemPrompt,
      model,
      temperature,
    });
    lastText = text;
    const parsed = parseJsonPayload(text);
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
  }

  throw new Error(
    `Local Ollama returned non-JSON output after ${maxAttempts} attempts. Last response: ${lastText.slice(
      0,
      240
    )}`
  );
};

